module.exports = __webpack_public_path__ + "static/media/bubble.c227d741.png";